import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

const NotFoundContainer = styled.div`
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 180px 20px 100px;
`;

const ErrorCode = styled.div`
  font-size: 120px;
  font-weight: 300;
  color: #1a1a1a;
  line-height: 1;
  letter-spacing: 4px;

  @media (max-width: 768px) {
    font-size: 80px;
  }
`;

const Divider = styled.div`
  width: 60px;
  height: 1px;
  background: #1a1a1a;
  margin: 30px 0;
  opacity: 0.4;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 400;
  color: #2c2c2c;
  margin: 0 0 15px 0;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const Description = styled.p`
  font-size: 16px;
  color: #666;
  max-width: 480px;
  line-height: 1.7;
  margin: 0 0 35px 0;
`;

const HomeButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 32px;
  background: #1a1a1a;
  color: white;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;

  &:hover {
    background: #000000;
    transform: translateY(-2px);
  }
`;

const NotFoundPage: React.FC = () => {
  return (
    <NotFoundContainer>
      <ErrorCode>404</ErrorCode>
      <Divider />
      <Title>Böyle bir sayfa bulunamadı</Title>
      <Description>
        Aradığınız sayfa taşınmış, adı değişmiş veya hiç var olmamış olabilir.
        Ana sayfaya dönmek için aşağıdaki butona tıklayın.
      </Description>
      <HomeButton to="/">
        <Home size={18} />
        Ana Sayfaya Dön
      </HomeButton>
    </NotFoundContainer>
  );
};

export default NotFoundPage;
